import * as _ from 'lodash'
import { copyObject } from '../../../../../utils'
import { getVariableValue, VariableDocumentT } from '../DocumentVariables'
import { AgreementT, JobT } from '../../../../../types/Job'
import { EstimateObj } from '../../InitObjectJob'

export const getVariablesEsitmate = (newJob: JobT, useDefault: boolean = true): Array<VariableDocumentT> => {
  return newJob.documents.estimate && newJob.documents.estimate.variables
    ? newJob.documents.estimate.variables
    : useDefault ? copyObject(EstimateObj.variables) : []
}

export const lineItemsEstimate = (newJob: JobT): Array<any> => {
  const lineItems = getVariableValue('lineItems', getVariablesEsitmate(newJob))
  return lineItems ? lineItems : []
}

export const estimateIsDirty = (newJob: JobT): Array<any> => {
  return getVariableValue('dirty', newJob.documents.estimate.variables)
}

export const getAgreementsEstimate = (job: JobT): Array<AgreementT> => {
  if (!job.documents || !job.documents.estimate || !job.documents.estimate.agreement) {
    return []
  }
  return _.isArray(job.documents.estimate.agreement) ? job.documents.estimate.agreement : []
}

const isNullEstimate = (newJob: JobT): boolean => {
  return newJob.documents.estimate && newJob.documents.estimate.variables ? false : true
}

export const isAgreedEstimate = (job: JobT): boolean => {
  if (isNullEstimate(job)) return false
  const agreements = getAgreementsEstimate(job)
  if (_.isArray(agreements) && agreements.length > 0) {
    const findItem = agreements.find((x) => _.isEqual(x.content, job.documents.estimate.variables))
    if (findItem) return true
  }
  return false
}
